import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import Modal from '../../Global/Modals/Modal';
import OutlinedSelectInput from '../../Global/Inputs/OutlinedSelect';
import classnames from 'classnames';
import Button from '@material-ui/core/Button';
import { Formik, FastField } from 'formik';
import ProgressButton from '../../Global/Buttons/Progress';
import Grid from '@material-ui/core/Grid';
import GridItem from '../../Global/GridItem';
import combineStyles from '../../../utils/combineStyles';
import LayoutStyles from '../../../styles/layout';
import TypographyStyles from '../../../styles/typography';
import ButtonStyles from '../../../styles/button';
import SpacingStyles from '../../../styles/helpers/spacing';
import _get from 'lodash/get';

import { AppContext } from '../../../AppProvider';

const styles = theme => ({
  titleWrapper: {
    display: 'flex',
    marginBottom: `${theme.spacing.unit * 2.125}px !important`,
    position: 'relative'
  },
  title: {
    flex: 1,
    fontWeight: 'bold !important'
  },
  resetLinkButton: {
    position: 'absolute',
    right: 0,
    top: -6
  },
  resetLink: {
    textTransform: 'capitalize',
    color: `${theme.palette.primary.main} !important`
  },
  modalFooter: {
    marginTop: `${theme.spacing.unit * 5}px !important`
  }
});

export class EditDefaultLocationModal extends Component {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    defaultLocationId: PropTypes.string,
    allOrgLocations: PropTypes.array.isRequired,
    onClose: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired
  };

  _handleOnClose = () => {
    this.props.onClose();
  };

  _handleOnSave = async defaultLocationId => {
    const { onSave } = this.props;
    try {
      await onSave(defaultLocationId);
      return true;
    } catch {
      return false;
    }
  };

  render() {
    const {
      classes,
      open,
      t,
      isSubmitting,
      allOrgLocations,
      defaultLocationId
    } = this.props;

    return (
      <Formik
        enableReinitialize={true}
        initialValues={{
          defaultLocationId
        }}
        onSubmit={async (defaultLocationId, actions) => {
          const saved = await this._handleOnSave(defaultLocationId);
          if (saved) {
            actions.resetForm();
          }
        }}
        onReset={(defaultLocationId, actions) => {
          actions.resetForm();
          this._handleOnClose();
        }}
        validateOnChange={false}
        validateOnBlur={false}
        render={({
          values,
          handleChange,
          handleSubmit,
          handleReset,
          dirty
        }) => (
          <Modal
            open={open}
            onClose={this._handleOnClose}
            classes={{
              footer: classes.modalFooter
            }}
            body={
              <Fragment>
                <div className={classes.titleWrapper}>
                  <p className={classnames(classes.headline6, classes.title)}>
                    {t('Edit Default Location')}
                  </p>
                </div>
                <Grid container spacing={16}>
                  <GridItem xs={12}>
                    <FastField
                      name={'location'}
                      onChange={handleChange}
                      render={({ field, form }) => {
                        return (
                          <OutlinedSelectInput
                            label={t('Default Location')}
                            value={_get(values, 'defaultLocationId', null)}
                            options={allOrgLocations.map(l => ({
                              value: l.id,
                              title: l.name
                            }))}
                            field={field}
                            form={form}
                          />
                        );
                      }}
                    />
                  </GridItem>
                </Grid>
              </Fragment>
            }
            footer={
              <Fragment>
                <div className={classes.spacer} />
                <Button
                  className={classes.button}
                  onClick={handleReset}
                  color={'primary'}
                  classes={{ label: classes.buttonLabel }}
                >
                  {t('Cancel')}
                </Button>
                <ProgressButton
                  onClick={handleSubmit}
                  className={classes.button}
                  classes={{
                    disabled: classes.buttonDisabled,
                    label: classes.buttonLabel
                  }}
                  color={'primary'}
                  disabled={!dirty || isSubmitting}
                  isSubmitting={isSubmitting}
                >
                  {t('Save')}
                </ProgressButton>
              </Fragment>
            }
          />
        )}
      />
    );
  }
}
EditDefaultLocationModal.contextType = AppContext;
const translatedEditDefaultLocationModal = withNamespaces()(
  EditDefaultLocationModal
);
export default withStyles(
  combineStyles(
    styles,
    LayoutStyles,
    TypographyStyles,
    ButtonStyles,
    SpacingStyles
  )
)(translatedEditDefaultLocationModal);
